import Backbone	from 'backbone'
import $ from 'jquery'

import icon from 'scoreboard/components/icon'
import i18n from 'scoreboard/components/i18n'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import { FILL } from '../shape-widget-properties'
import { SOLID, LINEAR, NONE } from '../shape-fill-type'

/**
 * View that renders the top-level shape fill selection item in a bootslide menu;
 * renders the menu item label and the currently selected shape icon
 */
const ShapeFillLabelView = Backbone.View.extend({
	className: 'shape-fill-label',

	initialize: function (opt) {
		this.listenTo(this.model.properties, 'change:fill',
			this.render.bind(this))
	},

	render: function () {
		let fill = this.model.properties.get(FILL)

		this.$el.html(i18n.get('dashboards.shapeFill')
			+ icon(`wob-rectangle-${fill}`))

		return this
	}
})

/**
 * View that renders a single option in the Shape Fill submenu
 */
const ShapeFillOption = BootslideMenu.MultipleChoiceOption.extend({
	property: FILL,

	className: BootslideMenu.MultipleChoiceOption.prototype.className + ' shape-fill-option',

	initialize: function (opt) {
		this.options = opt
		this.value = opt.fill
		this.widgetUpdater = opt.widgetUpdater

		BootslideMenu.MultipleChoiceOption.prototype.initialize.apply(this, arguments)

		let fillIcon = icon(`wob-rectangle-${this.value}`, 'wob-rectangle')
		let fillLabel = i18n.get(FILL_MESSAGE_CODES[this.value])
		this.label = $(`<span class="checkable-content">${fillIcon}${fillLabel}</span>`)[0]
	},

	updateModel (value) {
		this.widgetUpdater.setProperty(FILL, value)
	}
})

/**
 * Creates a menu item and submenu for selecting a shape fill in a bootslide menu
 */
function createShapeFillMenu ({ model, bootslideMenu }) {
	let targets = [SOLID, LINEAR, NONE].map(fill => {
		let contentView = new ShapeFillOption({
			fill,
			model: model.properties,
			widgetUpdater: bootslideMenu.options.widgetUpdater
		})

		return { contentView }
	})

	return {
		type: 'value-then-submenu',
		id: 'shape-fill',
		label: i18n.get('dashboards.shapeFill'),
		contentView: ShapeFillLabelView.extend({
			model
		}),
		target: targets
	}
}

const FILL_MESSAGE_CODES = {
	[SOLID]: 'dashboards.fill.solid',
	[LINEAR]: 'dashboards.fill.gradient',
	[NONE]: 'common.none'
}

export default createShapeFillMenu

createShapeFillMenu.__filename__ = 'dashboards/widgets/shape/config/create-shape-fill-menu.js'
